import React from "react";

const JQuery_Filters = () => {
  return (
    <div>
      <h1>JQuery_Filters</h1>
      <p>Placeholder component for: "JQuery_Filters"</p>
    </div>
  );
};

export default JQuery_Filters;
